<template>
  <vs-row>
    <!-- 그래프 1 -->
    <vs-col class="w-full pb-4">
      <single-year-chart-card :title="graph1.title" :year="graph1.year" :current-value="graph1.currentValue" :sum1="graph1.sum1" :show-sum="false" :max-y="100" unit="%" @change="yearChangeForGraph1" />
    </vs-col>

    <div class="w-full grid grid-cols-1 lg:grid-cols-2 gap-x-2 gap-y-4 mb-4">
      <!-- 그래프 2-->
      <vs-col>
        <monthly-comparison-card :title="graph2.title" :year="graph2.year" :month="12" :hide-month="true" :unit="graph2.unit" :heads="graph2.heads" :list="graph2.list" :getCol="getColForGraph2" @change="dateChangeForGraph2">
          <template v-if="projectId" slot="tools">
            <vs-button v-for="(button, idx) in getButtons" :key="idx" class="py-3 px-0 lg:px-8" type="border"
                       :color="button.dataType === graph2.dataType ? 'primary' : 'secondary'"
                       @click="dataTypeChangeForGraph2(button.dataType, button.label)">{{ button.label }}</vs-button>
          </template>
        </monthly-comparison-card>
      </vs-col>

      <!-- 그래프 3 -->
      <vs-col>
        <budget-execution-rate-card dateType="yyyy-mm" :title="graph3.title" :unit="graph3.unit" :year="graph3.year" :month="12" :hide-month="true" :list="graph3.list" @change="dateRangeChangeForGraph3">
          <template v-if="projectId" slot="tools">
            <vs-button v-for="(button, idx) in getButtons" :key="idx" class="py-3 px-0 lg:px-8" type="border"
                       :color="button.dataType === graph3.dataType ? 'primary' : 'secondary'"
                       @click="dataTypeChangeForGraph3(button.dataType, button.label)">{{ button.label }}</vs-button>
          </template>
        </budget-execution-rate-card>
      </vs-col>
    </div>
  </vs-row>
</template>

<script>
/* eslint-disable brace-style */
import MonthlyChartCard from "@/views/graph-detail/components/MonthlyChartCard";
import MonthlyComparisonCard from "@/views/graph-detail/components/MonthlyComparisonCard";
import DailyComparisonCard from "@/views/graph-detail/components/DailyComparisonCard";
import BudgetExecutionRateCard from "@/views/graph-detail/components/BudgetExecutionRateCard.vue";
import SingleYearChartCard from "@/views/graph-detail/components/SingleYearChartCard.vue";

export default {
  name: "GraphDetail33",
  components: {
    SingleYearChartCard,
    BudgetExecutionRateCard,
    DailyComparisonCard,
    MonthlyComparisonCard,
    MonthlyChartCard,
  },
  props: {
    comGroupList: Object,
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id) || 0;
    },
    graphId() {
      return Number(this.$route.params.graphId);
    },
    getButtons() {
      switch (this.getLevel) {
      case 1:
        return [
          {label: '부서(국)', dataType: 'company1'},
          {label: '부서(과)', dataType: 'company2'},
          { label: '행정동', dataType: 'address' },
          { label: '사업장', dataType: 'field' },
          { label: '예산항목', dataType: 'detail' },
        ];
      case 2:
        return [
          {label: '부서(국)', dataType: 'company0'},
          {label: '부서(과)', dataType: 'company1'},
          { label: '행정동', dataType: 'address' },
          { label: '사업장', dataType: 'field' },
          { label: '예산항목', dataType: 'detail' },
        ];
      case 3:
        return [
          {label: '부서(과)', dataType: 'company0'},
          { label: '행정동', dataType: 'address' },
          { label: '사업장', dataType: 'field' },
          { label: '예산항목', dataType: 'detail' },
        ];
      case 4:
        return [
          { label: '행정동', dataType: 'address' },
          { label: '사업장', dataType: 'field' },
          { label: '예산항목', dataType: 'detail' },
        ];
      }
    },
    getLevel() {
      const projects = this.$store.state.member.memberInfo.projects;
      if (projects) {
        for (const project of projects) {
          if (`${project.id}` === `${this.projectId}` && project.company.length > 0) {
            const path = project.company[0].pivot.company_path;
            return path.split("/").length - 1; // Level
          }
        }
      }
    },
  },
  data() {
    return {
      buttons: [
        { label: '부서(업체)명', dataType: 'company' },
        { label: '행정동', dataType: 'address' },
        { label: '사업장', dataType: 'field' },
        { label: '예산항목', dataType: 'detail' },
      ],
      boardIds: [409, 611],
      summaryKeys: {
        'detail' : ['안전보건예산_항목명', 'sum'],
        'field' : ['안전보건예산_사업장명', 'sum'],
        'address' : ['안전보건예산_사업장주소', 'sum'],
        'field_cat1' : ['안전보건예산_사업장구분', 'sum'],
        'company' : ['안전보건예산_항목명', 'sum'],
        'project' : ['안전보건예산_항목명', 'sum'],
      },
      graphData1: {},
      graphData2: {},
      graphData3: {},

      graph1: {
        title: "전체 원료·제조물 사업장 안전예산 집행률 현황",
        year: new Date().getFullYear(),
        currentValue: 0, // 선택한 년도
        sum1: "",
        sum2: "",
      },

      graph2: {
        title: "년도별 원료·제조물 사업장 안전예산 집행률 현황",
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        unit: "%",
        heads: [{ name: "No." }, { name: "부서(업체)명" }, { name: "예산" }, { name: "집행액" }, { name: "집행률" }],
        list: [],
        dataType: this.$route.params.proj_id ? "detail" : "project",
      },

      graph3: {
        title: "년도별 원료·제조물 사업장 안전예산 집행률 현황",
        unit: "",
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        list: [],
        dataType: this.$route.params.proj_id ? "detail" : "project",
      },
      cache: {},
    };
  },
  created() {},
  async mounted() {
    await this.loadDetailData();
    this.graph2.dataType = this.getButtons[0].dataType;
    this.graph3.dataType = this.getButtons[0].dataType;

    this.updateGraph1().then();
    this.updateGraph2().then();
    this.updateGraph3().then();

    this.$nextTick(() => {
      this.dataTypeChangeForGraph2(this.getButtons[0].dataType, this.getButtons[0].label);
    });
  },
  methods: {
    async loadDetailData(currentYear = 0, depth = -1) {
      if (!currentYear) {
        currentYear = new Date().getFullYear();
      }
      if (depth < 0) {
        depth = 1;
      }

      const cacheKey = `detail_${currentYear}_${depth}`;

      // 캐시에 저장되어 있으면, 캐시에서 불러온다
      if (this.cache[cacheKey]) {
        return JSON.parse(JSON.stringify(this.cache[cacheKey]));
      }
      // 캐시에 저장되어 있지 않으면, API에서 불러온다
      else {
        const params = {
          projectId: this.projectId,
          fieldCode: 'workplace-material',
          depth,
          currentYear,
          boardIds: [409, 611]
        };

        const data = await this.$store.dispatch("summary/LOAD_DONUT_15_DETAIL", params);
        this.cache[cacheKey] = data;
        return data;
      }
    },

    async updateGraph1() {
      const yyyy = this.graph1.year;
      const data = await this.loadDetailData(yyyy);
      const graph1Data = data.monthly;
      const currentYear = graph1Data[yyyy] ? graph1Data[yyyy] : [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      const prevYear = graph1Data[yyyy - 1] ? graph1Data[yyyy - 1] : [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

      // 첫번째 배열은 총 합이므로, 데이터에서 제외한다
      currentYear.shift();
      prevYear.shift();

      this.graph1.currentValue = Number(`${currentYear[currentYear.length - 1]}`);
      this.graph1.sum1 = `${currentYear[currentYear.length - 1]}`;
    },

    async updateGraph2() {
      const yyyy = this.graph2.year;
      let depth = 1;
      if (this.graph2.dataType === 'company0') {
        depth = 0;
      } else if (this.graph2.dataType === 'company1') {
        depth = 1;
      } else if (this.graph2.dataType === 'company2') {
        depth = 2;
      }
      const data = await this.loadDetailData(yyyy, depth)

      let graph2Data = [];
      switch (this.graph2.dataType) {
      case "company0":
      case "company1":
      case "company2":
        graph2Data = data.company;
        break;
      case "field":
        graph2Data = data.field;
        break;
      case "detail":
        graph2Data = data.budgetItem;
        break;
      case "address":
        graph2Data = data.fieldAddress;
        break;
      default:
        return;
      }

      const currentYear = yyyy;
      const currentMonth = this.graph2.month;
      const prevYear = currentMonth === 1 ? currentYear - 1 : currentYear;
      const prevMonth = currentMonth === 1 ? 12 : currentMonth - 1;

      const currentData = graph2Data[currentYear][currentMonth];
      const prevData = graph2Data[prevYear][prevMonth];

      const list = [];
      let no = 1;

      for (const row of currentData) {
        const prevRow = prevData.find((item) => item.label === row.label);
        const gap = prevRow ? row.rate - prevRow.rate : row.rate;
        list.push({
          no,
          name: row.label,
          budget: `${new Intl.NumberFormat().format(row.budget)  } 원`,
          budgetExe: `${new Intl.NumberFormat().format(row.accumulated)  } 원`,
          budgetExeRate: `${ row.rate }%`,
          gap,
        });
        no += 1;
      }

      this.$set(this.graph2, 'list', list);
    },

    async updateGraph3() {
      const yyyy = this.graph3.year;
      let depth = 1;
      if (this.graph3.dataType === 'company0') {
        depth = 0;
      } else if (this.graph3.dataType === 'company1') {
        depth = 1;
      } else if (this.graph3.dataType === 'company2') {
        depth = 2;
      }
      const data = await this.loadDetailData(yyyy, depth)
      let graph3Data = [];
      switch (this.graph3.dataType) {
      case "company0":
      case "company1":
      case "company2":
        graph3Data = data.company;
        break;
      case "field":
        graph3Data = data.field;
        break;
      case "detail":
        graph3Data = data.budgetItem;
        break;
      case "address":
        graph3Data = data.fieldAddress;
        break;
      default:
        return;
      }

      const currentYear = yyyy;
      const currentMonth = this.graph3.month;
      const currentData = graph3Data[currentYear][currentMonth];

      const list = [];

      for (const row of currentData) {
        list.push({
          name: row.label,
          label: row.label,
          budgetExeRate: `${ row.rate }%`,
        });
      }

      this.graph3.list = list;
    },

    yearChangeForGraph1(year) {
      this.graph1.year = year;
      this.updateGraph1();
    },

    getColForGraph2(index, value) {
      if (index === 0) return value.no;
      if (index === 1) return value.name;
      if (index === 2) return value.budget;
      if (index === 3) return value.budgetExe;
      if (index === 4) return value.budgetExeRate;
      return "";
    },
    dateChangeForGraph2(year, month) {
      this.graph2.year = year;
      this.graph2.month = month;
      this.updateGraph2();
    },
    dataTypeChangeForGraph2(dataType, label) {
      this.graph2.heads[1].name = label
      if (this.projectId) {
        this.graph2.dataType = dataType;

        // nextTick
        this.$nextTick(() => {
          this.updateGraph2();
        });
      }
    },

    dateRangeChangeForGraph3(year, month) {
      this.graph3.year = year;
      this.graph3.month = month;
      this.updateGraph3();
    },
    dataTypeChangeForGraph3(dataType) {
      if (this.projectId) {
        this.graph3.dataType = dataType;
      }
      this.updateGraph3();
    },
  },
};
</script>

<style scoped></style>
